// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton__qh8TZ","textload":"textload__jqnh6","card":"card__JWQ5r","loadbar":"loadbar__IawzE textload__jqnh6","bottom":"bottom__coLve"};